<template>
  <rounded-bar-chart :chartData="info" :options="options" style="height: 30vh" class="chart-completed"/>
</template>

<script>
import roundedBarChart from "../roundedBarChart";
// import Completed from "./completed";
import axios from "axios";

function hexToRgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  result = result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      }
    : null;

  return `rgb(${result.r}, ${result.g}, ${result.b})`;
}

export default {
  props: ["userId"],
  data() {
    return {
      loading: true,
      options: {
        maintainAspectRatio: false,
        legend: {
          position: "bottom",
          labels: {
            fontColor: "white"
          },
        },
        tooltips: {
          callbacks: {
            label: toolTipItem => `${Number.parseInt(toolTipItem.yLabel)}%`
          }
        },
        scales: {
          xAxes: [{
            display: false
          }],
          yAxes: [
            {
              fontColor: "white",
              display: true,
              ticks: {
                fontColor: "white",
                beginAtZero: true,
                min: 0,
                max: 100,
                stepSize: 20
              }
            }
          ]
        }
      },
      info: {}
    };
  },
  mounted() {
    let id = this.userId;
    axios
      .get(`${process.env.VUE_APP_API_URL}user/${id}/category_complete/`)
      .then(({ data }) => {
        let labels = [];
        let dataSets = [];

        Object.keys(data).forEach(groupName => {
          let info = data[groupName];
          let color = info.color ? hexToRgb(info.color) : undefined;
          dataSets.push({
            backgroundColor: color,
            data: [info.percent],
            label: groupName
          });
        });
        this.info = {
          labels,
          datasets: dataSets
        };
        this.loading = false;
      });
  },
  components: {
    roundedBarChart
  }
};
</script>

<style>
.chart {
  max-height: 30vh;
}
</style>
